export default __webpack_public_path__ + "static/media/ai-guild-background.03aa2d1a.png";